import * as React from 'react'
import { useEffect } from 'react'
import { useSubmitPickingListPicksMutation } from '../../hooks/queries/picking_lists'
import { PickingListSubmitResult, StagedPick } from '../../api/api_data_types'
import type { ApiError } from '../helpers/error'

interface SaveAllPickingListLinesButtonProps {
  jobId: string
  buttonTitle?: string
  buttonClass?: string
  changedQuantities: Record<string, StagedPick>
  setChangedQuantities: React.Dispatch<React.SetStateAction<Record<string, StagedPick>>>
  setError: React.Dispatch<React.SetStateAction<ApiError | null>>
  setSubmitResult: (result: PickingListSubmitResult | null) => void
}

export default function SaveAllPickingListLinesButton({
  jobId,
  buttonTitle = 'Gem alle',
  buttonClass = 'btn btn-primary',
  changedQuantities,
  setChangedQuantities,
  setError,
  setSubmitResult,
}: SaveAllPickingListLinesButtonProps) {
  const mutation = useSubmitPickingListPicksMutation(jobId, changedQuantities)
  const { mutate, isLoading, isError, error, data } = mutation

  useEffect(() => {
    if (isError) {
      setError(error)
    }
  }, [error, isError, setError])

  useEffect(() => {
    if (data) {
      setError(null)
      setSubmitResult(data)
      setChangedQuantities((currentChangedQuantities) => {
        const succeededItemNumbers = new Set([...data.succeeded, ...data.skipped])
        const nextChangedQuantities = { ...currentChangedQuantities }
        Object.entries(nextChangedQuantities).forEach(([rowKey, pick]) => {
          if (succeededItemNumbers.has(pick.item_no)) {
            delete nextChangedQuantities[rowKey]
          }
        })
        return nextChangedQuantities
      })
    }
  }, [data, setChangedQuantities, setError, setSubmitResult])

  const hasChangedQuantities = Object.keys(changedQuantities).length > 0

  return (
    <button
      type="button"
      className={buttonClass}
      onClick={() => {
        setError(null)
        setSubmitResult(null)
        mutate()
      }}
      disabled={isLoading || !hasChangedQuantities}
    >
      {isLoading ? <i className="fa fa-spinner fa-spin" /> : buttonTitle}
    </button>
  )
}
